import React from 'react';
import BaseEChart from './BaseEChart';
import { buildPerformanceHistoryOption } from './performanceTrendOptions';
import type { PerformanceHistoryChartData } from '@app-types/performanceTrends';

export interface FinancialTrendChartProps {
  data: PerformanceHistoryChartData;
  height?: number;
}

/**
 * Annual performance history chart: a single red vertical bar series
 * (see PT03 / section 6.1). Renders through BaseEChart only.
 */
const FinancialTrendChart: React.FC<FinancialTrendChartProps> = ({ data, height = 229 }) => (
  <BaseEChart
    option={buildPerformanceHistoryOption(data)}
    height={height}
    ariaLabel={`${data.title}の推移チャート`}
    animate
  />
);

export default FinancialTrendChart;
